const TOKEN_KEY = 'lms_auth_token';

export const ROLES = {
  STUDENT: 'student',
  ADMIN: 'admin',
  INSTRUCTOR: 'instructor',
  AGENCY: 'agency',
};

export const ADMIN_SCOPES = {
  ACADEMIC: 'academic',
  STUDENT: 'student',
  ADMIN: 'admin',
};

export const ADMIN_SCOPE_ORDER = [
  ADMIN_SCOPES.ACADEMIC,
  ADMIN_SCOPES.STUDENT,
  ADMIN_SCOPES.ADMIN,
];

export function adminScopes(profile) {
  if (!profile || profile.role !== ROLES.ADMIN) return [];
  if (profile.is_super_admin === true) return ADMIN_SCOPE_ORDER;
  const raw = Array.isArray(profile.access_scope) ? profile.access_scope : null;
  if (!raw) return ADMIN_SCOPE_ORDER;
  const scopes = raw.map((scope) => String(scope || '').toLowerCase());
  if (scopes.includes(ADMIN_SCOPES.ADMIN)) return ADMIN_SCOPE_ORDER;
  return ADMIN_SCOPE_ORDER.filter((scope) => scopes.includes(scope));
}

export function hasAdminScope(profile, scope) {
  if (!profile || profile.role !== ROLES.ADMIN) return false;
  const scopes = adminScopes(profile);
  return scopes.includes(ADMIN_SCOPES.ADMIN) || scopes.includes(scope);
}

export function adminHome(profile) {
  if (hasAdminScope(profile, ADMIN_SCOPES.ADMIN)) return '/admin/dashboard';
  if (hasAdminScope(profile, ADMIN_SCOPES.ACADEMIC)) return '/admin/courses';
  if (hasAdminScope(profile, ADMIN_SCOPES.STUDENT)) return '/admin/students';
  return '/admin/profile';
}

export function roleHome(profileOrRole) {
  if (typeof profileOrRole === 'string') {
    if (profileOrRole === ROLES.ADMIN) return '/admin/dashboard';
    if (profileOrRole === ROLES.INSTRUCTOR) return '/instructor/dashboard';
    if (profileOrRole === ROLES.AGENCY) return '/agency/dashboard';
    return '/student/dashboard';
  }
  if (profileOrRole?.role === ROLES.ADMIN) return adminHome(profileOrRole);
  if (profileOrRole?.role === ROLES.INSTRUCTOR) return '/instructor/dashboard';
  if (profileOrRole?.role === ROLES.AGENCY) return '/agency/dashboard';
  return '/student/dashboard';
}

export function getToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) {
      window.localStorage.setItem(TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    // ignore (private mode / blocked storage)
  }
}

export function clearToken() {
  setToken(null);
}
